module.exports = __webpack_public_path__ + "img/module-brand-logo.9ccb9e5a.svg";